import { render, staticRenderFns } from "./EnvioItem.vue?vue&type=template&id=f7ecb030&scoped=true&"
import script from "./EnvioItem.vue?vue&type=script&lang=js&"
export * from "./EnvioItem.vue?vue&type=script&lang=js&"
import style0 from "./EnvioItem.vue?vue&type=style&index=0&id=f7ecb030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ecb030",
  null
  
)

export default component.exports